const productDetail = {
  title: ({
    product: {
      brand,
      categoryPath: { category },
    },
  }) => {
    return `${brand} ${category} | italist, ALWAYS LIKE A SALE`;
  },
  description: ({ product: { productName } }) =>
    `Shop ${productName} and save up to 40%. EXPRESS international shipping!`,
};

export default productDetail;
